module.exports = __webpack_public_path__ + "static/media/LOGO.6dbfee7a.svg";